/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../model/document';
import '../model/personal_attributes';
import '../model/business_attributes';
import '../model/verification';
import '../model/vendor';
import '../../privacyvault/model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "identityverifier": {
        "nested": {
          "service": {
            "nested": {
              "CreateVerificationRequest": {
                "fields": {
                  "idempotenceKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "productIntent": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "clientKey": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "clientComment": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "documents": {
                    "type": ".squareup.identityverifier.model.Document",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "skipIndexing": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "callbackUrl": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "personalAttributes": {
                    "type": ".squareup.identityverifier.model.PersonalAttributes",
                    "id": 5
                  },
                  "businessAttributes": {
                    "type": ".squareup.identityverifier.model.BusinessAttributes",
                    "id": 7
                  }
                },
                "nested": {
                  "attributes_data": {
                    "oneof": ["personalAttributes", "businessAttributes"]
                  }
                }
              },
              "CreateSyncVerificationRequest": {
                "fields": {
                  "productIntent": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientKey": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "clientComment": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "skipIndexing": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "personalAttributes": {
                    "type": ".squareup.identityverifier.model.PersonalAttributes",
                    "id": 4
                  },
                  "businessAttributes": {
                    "type": ".squareup.identityverifier.model.BusinessAttributes",
                    "id": 5
                  }
                },
                "nested": {
                  "attributes_data": {
                    "oneof": ["personalAttributes", "businessAttributes"]
                  }
                }
              },
              "GetVerificationRequest": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetVerificationResponse": {
                "fields": {
                  "verification": {
                    "type": ".squareup.identityverifier.model.Verification",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetVerificationDetailsRequest": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetVerificationDetailsResponse": {
                "fields": {
                  "verification": {
                    "type": ".squareup.identityverifier.model.Verification",
                    "id": 2,
                    "rule": "optional"
                  },
                  "interpretation": {
                    "type": ".squareup.identityverifier.model.Interpretation",
                    "id": 3,
                    "rule": "optional"
                  },
                  "vendorInteractions": {
                    "type": ".squareup.identityverifier.model.VendorInteraction",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "personalAttributes": {
                    "type": ".squareup.identityverifier.model.PersonalAttributes",
                    "id": 1
                  },
                  "businessAttributes": {
                    "type": ".squareup.identityverifier.model.BusinessAttributes",
                    "id": 5
                  }
                },
                "nested": {
                  "supplied_attributes": {
                    "oneof": ["personalAttributes", "businessAttributes"]
                  }
                }
              },
              "BatchGetVerificationDetailsRequest": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "BatchGetVerificationDetailsResponse": {
                "fields": {
                  "verificationDetails": {
                    "type": ".squareup.identityverifier.service.GetVerificationDetailsResponse",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "unprocessedIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "RedactVerificationRequest": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "entity": {
                    "type": ".squareup.privacyvault.model.Entity",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RedactVerificationResponse": {
                "fields": {}
              },
              "GetVerificationSearchRequest": {
                "fields": {
                  "searchCriteria": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "requestOptions": {
                    "type": ".squareup.identityverifier.service.RequestOptions",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RequestOptions": {
                "fields": {
                  "searchByIndex": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetVerificationSearchResponse": {
                "fields": {
                  "productIntentMap": {
                    "type": ".squareup.identityverifier.service.ProductIntentMap",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ProductIntentMap": {
                "fields": {
                  "verificationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "productIntent": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "VerificationService": {
                "methods": {
                  "CreateVerification": {
                    "requestType": ".squareup.identityverifier.service.CreateVerificationRequest",
                    "responseType": ".squareup.identityverifier.service.GetVerificationResponse"
                  },
                  "CreateSyncVerification": {
                    "requestType": ".squareup.identityverifier.service.CreateSyncVerificationRequest",
                    "responseType": ".squareup.identityverifier.service.GetVerificationResponse"
                  },
                  "GetVerification": {
                    "requestType": ".squareup.identityverifier.service.GetVerificationRequest",
                    "responseType": ".squareup.identityverifier.service.GetVerificationResponse"
                  },
                  "GetVerificationDetails": {
                    "requestType": ".squareup.identityverifier.service.GetVerificationDetailsRequest",
                    "responseType": ".squareup.identityverifier.service.GetVerificationDetailsResponse"
                  },
                  "BatchGetVerificationDetails": {
                    "requestType": ".squareup.identityverifier.service.BatchGetVerificationDetailsRequest",
                    "responseType": ".squareup.identityverifier.service.BatchGetVerificationDetailsResponse"
                  },
                  "RedactVerification": {
                    "requestType": ".squareup.identityverifier.service.RedactVerificationRequest",
                    "responseType": ".squareup.identityverifier.service.RedactVerificationResponse"
                  },
                  "GetVerificationSearch": {
                    "requestType": ".squareup.identityverifier.service.GetVerificationSearchRequest",
                    "responseType": ".squareup.identityverifier.service.GetVerificationSearchResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.CreateVerificationRequest && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.CreateSyncVerificationRequest && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.GetVerificationRequest && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.GetVerificationResponse && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.GetVerificationDetailsRequest && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.GetVerificationDetailsResponse && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.BatchGetVerificationDetailsRequest && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.BatchGetVerificationDetailsResponse && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.RedactVerificationRequest && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.RedactVerificationResponse && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.GetVerificationSearchRequest && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.RequestOptions && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.GetVerificationSearchResponse && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.ProductIntentMap && !$root.nested?.squareup?.nested?.identityverifier?.nested?.service?.nested?.VerificationService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreateVerificationRequest @ squareup/identityverifier/service/service.proto at 97:1
 */
export const CreateVerificationRequest = $root.lookupType('squareup.identityverifier.service.CreateVerificationRequest');
fixType(CreateVerificationRequest, {
  idempotenceKey: {
    notEmpty: true
  },
  productIntent: {
    notEmpty: true
  },
  clientKey: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateVerificationRequest);
/**
 * SOURCE CreateSyncVerificationRequest @ squareup/identityverifier/service/service.proto at 167:1
 */
export const CreateSyncVerificationRequest = $root.lookupType('squareup.identityverifier.service.CreateSyncVerificationRequest');
fixType(CreateSyncVerificationRequest, {
  productIntent: {
    notEmpty: true
  },
  clientKey: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CreateSyncVerificationRequest);
/**
 * SOURCE GetVerificationRequest @ squareup/identityverifier/service/service.proto at 215:1
 */
export const GetVerificationRequest = $root.lookupType('squareup.identityverifier.service.GetVerificationRequest');
fixType(GetVerificationRequest, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetVerificationRequest);
/**
 * SOURCE GetVerificationResponse @ squareup/identityverifier/service/service.proto at 220:1
 */
export const GetVerificationResponse = $root.lookupType('squareup.identityverifier.service.GetVerificationResponse');
fixType(GetVerificationResponse, {
  verification: {
    required: true
  }
});
Builder.createAndAttachToType(GetVerificationResponse);
/**
 * SOURCE GetVerificationDetailsRequest @ squareup/identityverifier/service/service.proto at 225:1
 */
export const GetVerificationDetailsRequest = $root.lookupType('squareup.identityverifier.service.GetVerificationDetailsRequest');
fixType(GetVerificationDetailsRequest, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetVerificationDetailsRequest);
/**
 * SOURCE GetVerificationDetailsResponse @ squareup/identityverifier/service/service.proto at 230:1
 */
export const GetVerificationDetailsResponse = $root.lookupType('squareup.identityverifier.service.GetVerificationDetailsResponse');
fixType(GetVerificationDetailsResponse, {
  verification: {
    required: true
  }
});
Builder.createAndAttachToType(GetVerificationDetailsResponse);
/**
 * SOURCE BatchGetVerificationDetailsRequest @ squareup/identityverifier/service/service.proto at 257:1
 */
export const BatchGetVerificationDetailsRequest = $root.lookupType('squareup.identityverifier.service.BatchGetVerificationDetailsRequest');
fixType(BatchGetVerificationDetailsRequest, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BatchGetVerificationDetailsRequest);
/**
 * SOURCE BatchGetVerificationDetailsResponse @ squareup/identityverifier/service/service.proto at 262:1
 */
export const BatchGetVerificationDetailsResponse = $root.lookupType('squareup.identityverifier.service.BatchGetVerificationDetailsResponse');
fixType(BatchGetVerificationDetailsResponse);
Builder.createAndAttachToType(BatchGetVerificationDetailsResponse);
/**
 * SOURCE RedactVerificationRequest @ squareup/identityverifier/service/service.proto at 267:1
 */
export const RedactVerificationRequest = $root.lookupType('squareup.identityverifier.service.RedactVerificationRequest');
fixType(RedactVerificationRequest, {
  id: {
    notEmpty: true
  },
  entity: {
    required: true
  }
});
Builder.createAndAttachToType(RedactVerificationRequest);
/**
 * SOURCE RedactVerificationResponse @ squareup/identityverifier/service/service.proto at 280:1
 */
export const RedactVerificationResponse = $root.lookupType('squareup.identityverifier.service.RedactVerificationResponse');
fixType(RedactVerificationResponse);
Builder.createAndAttachToType(RedactVerificationResponse);
/**
 * SOURCE GetVerificationSearchRequest @ squareup/identityverifier/service/service.proto at 282:1
 */
export const GetVerificationSearchRequest = $root.lookupType('squareup.identityverifier.service.GetVerificationSearchRequest');
fixType(GetVerificationSearchRequest, {
  searchCriteria: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetVerificationSearchRequest);
/**
 * SOURCE RequestOptions @ squareup/identityverifier/service/service.proto at 287:1
 */
export const RequestOptions = $root.lookupType('squareup.identityverifier.service.RequestOptions');
fixType(RequestOptions);
Builder.createAndAttachToType(RequestOptions);
/**
 * SOURCE GetVerificationSearchResponse @ squareup/identityverifier/service/service.proto at 291:1
 */
export const GetVerificationSearchResponse = $root.lookupType('squareup.identityverifier.service.GetVerificationSearchResponse');
fixType(GetVerificationSearchResponse);
Builder.createAndAttachToType(GetVerificationSearchResponse);
/**
 * SOURCE ProductIntentMap @ squareup/identityverifier/service/service.proto at 296:1
 */
export const ProductIntentMap = $root.lookupType('squareup.identityverifier.service.ProductIntentMap');
fixType(ProductIntentMap);
Builder.createAndAttachToType(ProductIntentMap);
/**
 * SOURCE VerificationService @ squareup/identityverifier/service/service.proto at 18:1
 */
export const VerificationService = $root.lookupService('squareup.identityverifier.service.VerificationService');